import Locally from './locally';

import config from 'config';

export const local = new Locally({
  compress: config.localDataCompress || false,
  prefix: 'sk_fe:'
});

export function prefixedStore({prefix}) {
  return {
    get(key) {
      return local.get(prefix + key);
    },
    set(key, val) {
      return local.set(prefix + key, val);
    },
    remove(key) {
      return local.remove(prefix + key);
    }
  };
}

export const logsBackup = prefixedStore({
  prefix: 'logs:'
});

const permanentErrorsBackup = prefixedStore({
  prefix: 'perm_errs:'
});
permanentErrorsBackup.set('items', []);
permanentErrorsBackup.append = item => {
  const items = permanentErrorsBackup.get('items');
  items.unshift(item);
  if (items.length > config.maxPermanentsErrorsBackupSize) {
    items.length = config.maxPermanentsErrorsBackupSize;
  }
  permanentErrorsBackup.set('items', items);
};

export {permanentErrorsBackup};

const _stateBackup = prefixedStore({
  prefix: 'state_backup'
});

export const stateBackup = {
  get(key) {
    const state = _stateBackup.get('');

    return state && state[key && key.toString()];
  },
  set(key, val) {
    const state = _stateBackup.get('') || {};
    state[key && key.toString()] = val;
    _stateBackup.set('', state);
  },
  remove(key) {
    const state = _stateBackup.get('');
    if (state) {
      delete state[key && key.toString()];
    }
    _stateBackup.set('', state);
  },
  keys() {
    const state = _stateBackup.get('');

    return Object.keys(state || {});
  }
};
